import { render } from "./ChannelShell.vue?vue&type=template&id=81914a5a&scoped=true"
import script from "./ChannelShell.vue?vue&type=script&lang=js"
export * from "./ChannelShell.vue?vue&type=script&lang=js"

import "./ChannelShell.vue?vue&type=style&index=0&id=81914a5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81914a5a"]])

export default __exports__